import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Select from 'react-select';

import CustomDropdown from '@components/CustomDropdown';
import { toastError, toastSuccess } from '@components/Toast';

import { supplierTypeWiseFieldParams } from '@features/filter/static/filterUtil';

import { fetchSupplierTypeWiseList } from '@store/actions/SupplierAction';
import { getBrands } from '@store/design/action';
import { getAllBrands } from '@store/reducers';

import ApiClient from '@lib/apiClient';

import { _getKey, validateFloatNumber } from '@utils/Util';

const TagSupplier = ({
	show,
	handleClose,
	materialId,
	supplierType,
	requestedPage = 'SUPPLIER',
	callback,
	materialType,
	supplierInfo = null
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const [price, setPrice] = useState('');
	const [referenceNumber, setReferenceNumber] = useState('');
	const [selectedBrands, setSelectedBrands] = useState([]);
	const [selectedSupplier, setSelectedSupplier] = useState(null);
	const [suppliers, setSuppliers] = useState([]);
	const [capacity, setCapacity] = useState('');
	const [leadTimeInDays, setLeadTimeInDays] = useState('');
	const [moq, setMoq] = useState('');
	const [oldSupplierId, setOldSupplierId] = useState(null);
	const filterFields = useSelector((store) => store.filterFieldStore);
	const dispatch = useDispatch();
	const { id } = useParams();

	const getMaterialType = (name) => {
		switch (name) {
			case 'FABRIC':
				return 'MAIN_FABRIC';
			case 'WASHING':
				return 'WASHING_PROCESS';
			case 'ACCESSORIES':
				return 'BRANDING';
			default:
				return name;
		}
	};

	useEffect(() => {
		if (supplierInfo !== null) {
			setOldSupplierId(supplierInfo.id);
			setSelectedSupplier({ id: supplierInfo.id, value: supplierInfo.name });
			setReferenceNumber(supplierInfo.supplierMaterialReferenceNumber);
			setPrice(supplierInfo.price);
			setMoq(supplierInfo.moq);
			setLeadTimeInDays(supplierInfo.leadTimeInDays);
			setCapacity(supplierInfo.capacity);
			let tmpBrands = supplierInfo?.brandResponseList?.map((item) => ({
				id: item.id,
				text: item.name,
				value: item.name,
				label: item.name
			}));
			setSelectedBrands(tmpBrands);
		}
	}, [id, supplierInfo]);

	const fetchSupplierList = (value) => {
		setIsLoading(true);
		let params = `?size=1000&materialType=${getMaterialType(materialType)}`;
		if (value) {
			params += `&name=${value}`;
		}
		ApiClient.GET('searchSupplier', params)
			.then((response) => {
				let tmpData = response.data.data?.map((item) => ({ id: item.id, value: item.name }));
				setSuppliers(tmpData);
				setIsLoading(false);
			})
			.catch(() => {
				setIsLoading(false);
			});
	};

	let brands = useSelector(getAllBrands);
	brands = brands.map((item) => {
		return {
			id: item.id,
			text: item.name,
			value: item.name,
			label: item.name
		};
	});

	const closeModal = (value) => {
		setOldSupplierId(null);
		setSelectedSupplier(null);
		setReferenceNumber('');
		setPrice('');
		setMoq('');
		setLeadTimeInDays('');
		setCapacity('');
		setSelectedBrands([]);
		handleClose(value);
	};

	const onSubmit = async () => {
		setIsLoading(true);
		await ApiClient.POST('addSupplierMaterialtag', {
			price: price ? price : null,
			oldSupplierId,
			leadTimeInDays: leadTimeInDays ? leadTimeInDays : null,
			capacity: capacity ? capacity : null,
			moq: moq ? moq : null,
			referenceNumber,
			brandIds: selectedBrands?.map((item) => item.id),
			materialId,
			supplierId: requestedPage === 'MATERIAL' ? selectedSupplier.id : id,
			requestedPage: requestedPage
		})
			.then(({ data }) => {
				if (requestedPage !== 'MATERIAL') {
					dispatch(
						fetchSupplierTypeWiseList(id, supplierTypeWiseFieldParams(supplierType, filterFields))
					);
					toastSuccess(data.message);
				} else {
					callback(data);
					toastSuccess('Supplier tagged successfully');
				}
				setIsLoading(false);

				closeModal('updated');
			})
			.catch(({ response }) => {
				setIsLoading(false);
				closeModal();
				toastError(response.data.message);
			});
	};

	useEffect(() => {
		if (requestedPage === 'MATERIAL') {
			fetchSupplierList();
		}
		dispatch(getBrands()).finally(() => {
			setIsLoading(false);
		});
	}, []);

	const onChangeBrandInfo = (selectedItems) => {
		setSelectedBrands(selectedItems);
	};

	const onItemClick = (item) => {
		setSelectedSupplier(item);
	};

	return (
		<Modal show={show} onHide={closeModal} centered className="width-784-popup">
			<div className="common-popup width-784 additional-info-popup">
				<Modal.Header closeButton>
					<Modal.Title>
						<div className="popup-tilte">
							<h3 className="semibold-16 mb-0">Tag {supplierType}</h3>
						</div>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="common-popup-body">
						<div className="container px-0">
							<div className="row">
								{requestedPage === 'MATERIAL' && (
									<div className="col-md-12 mb-3">
										<div className="form-group no-shadow-react-select size36 mb-0">
											<CustomDropdown
												type="addItem"
												title={'Supplier'}
												onItemClick={onItemClick}
												items={suppliers}
												onItemSearch={fetchSupplierList}
												selectedItem={selectedSupplier?.value}
											/>
										</div>
									</div>
								)}
								<div className="col-md-6 mb-3">
									<div className="input-group mb-0">
										<label htmlFor="refNumber">Supplier ref number</label>
										<input
											type="text"
											autoComplete="off"
											id="refNumber"
											className="form-control"
											aria-label="Text input with dropdown button"
											placeholder=""
											value={referenceNumber}
											onChange={(e) => setReferenceNumber(e.target.value)}
										/>
									</div>
								</div>
								<div className="col-md-6 mb-3">
									<div className="input-group mb-0">
										<label htmlFor="price">Price</label>
										<input
											type="text"
											autoComplete="off"
											id="price"
											className="form-control"
											aria-label="Text input with dropdown button"
											placeholder="$"
											onChange={(e) => setPrice(e.target.value)}
											value={price}
											onKeyPress={validateFloatNumber}
										/>
									</div>
								</div>
								<div className="col-md-12 mb-3">
									<div className="form-group no-shadow-react-select size36 mb-0">
										<label htmlFor="brand">Brand</label>
										<Select
											key={_getKey()}
											onChange={onChangeBrandInfo}
											isMulti
											options={brands}
											defaultValue={selectedBrands}
										/>
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-group">
										<label htmlFor="lead">Lead time</label>
										<input
											type="number"
											id="lead"
											placeholder="Days"
											onChange={(e) =>
												setLeadTimeInDays(
													e.target.value === '' ? null : e.target.value
												)
											}
											value={leadTimeInDays}
										/>
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-group">
										<label htmlFor="MOQ">MOQ</label>
										<input
											type="text"
											autoComplete="off"
											id="MOQ"
											value={moq}
											onChange={(e) => setMoq(e.target.value)}
										/>
									</div>
								</div>
								<div className="col-md-12 mb-3">
									<div className="input-group mb-0">
										<label htmlFor="Capacity">Capacity</label>
										<input
											type="number"
											id="Capacity"
											className="form-control"
											aria-label="Text input with dropdown button"
											value={capacity}
											onChange={(e) => setCapacity(e.target.value)}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="footer-buttons text-right">
						<button className="button outline size32" onClick={closeModal}>
							Cancel
						</button>
						<button
							disabled={isLoading}
							className="button size32 ml-2"
							onClick={() => onSubmit()}
						>
							Submit
						</button>
					</div>
				</Modal.Footer>
			</div>
		</Modal>
	);
};

export default TagSupplier;
